import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {UnitTools} from './unitTools.js';


/* global customElements */
class TrailerGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var trailerGrid = this;
		setTimeout(function(){
			trailerGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var trailerGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'trailerRefNo',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'trailerId',
								description: 'Trailer Id'								
							},
							{
								code: 'trailerVinNo',
								description: 'Vin'	
							},
							{
								code: 'comment',
								description: 'Comment'	
							},
							{
								code: 'trailerRefNo',
								description: 'Reference No'	
							},							
							{
								code: 'tags',
								description: 'Tag'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['TRAILER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRAILER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRAILER_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:folder-open', ' Details')						
					],
					listeners: {
						click: function() {
							actionDetails(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'status',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRAILER_MANAGEMENT:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Update Status')						
					],
					listeners: {
						click: function() {
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'dl-action-button',
					itemid: 'refs',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRAILER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:chevron-circle-right', ' References')						
					],
					listeners: {
						click: function() {
							actionMultiRefs(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['TRAILER_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'trailerRefNo',
					header: 'Reference No',
					width: '7em'
				},	
				{						
					path: 'trailerVinNo',
					header: 'Vin',
					width: '7em'
				},
				{						
					path: 'trailerMakeDesc',
					header: 'Make',
					width: '7em'
				},
				{						
					path: 'trailerTypeDesc',
					header: 'Type',
					width: '7em'
				},				
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'tags',
					header: 'Tags',
					width: '12em',
					renderer: function(root, column, rowData) {
						var tags = [];
						if (rowData.item.tags) { 
							rowData.item.tags.forEach(function(tagItem) {
								tags.push(
									'<span class="tag-badge" style="margin: 3px;">' + tagItem + '</span>'
								);
							});
						}
						
						root.innerHTML = tags.join('');
					}
				},
				{						
					path: 'trailerId',
					header: 'Trailer Id',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'details').disabled = false;
						ElementUtil.query(toolbar, 'status').disabled = false;
						ElementUtil.query(toolbar, 'refs').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'details').disabled = true;
						ElementUtil.query(toolbar, 'status').disabled = true;
						ElementUtil.query(toolbar, 'refs').disabled = true;
					}
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;
					ElementUtil.query(toolbar, 'details').disabled = true;
					ElementUtil.query(toolbar, 'status').disabled = true;
					ElementUtil.query(toolbar, 'refs').disabled = true;
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'trailerRefNo',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							status: ElementUtil.query(toolbarFilter, 'status').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value							
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;
							
							grid.selectedItems = [];
							gridSelectionChange();
							
							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						UnitService.getTrailerService().getTrailers(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',			
			children: [				
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					UnitService.getTrailerService().exportTrailers(grid.currentFilter);
				}
			}
		});		
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		trailerGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(trailerGrid, toolbarFilter, ['filterType','filterValue','status'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Trailer' : 'Add Trailer',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'trailerRefNo',
											label: 'Reference No',
											required: true,
											maxLength: 80											
										},										
										{
											tag: 'vaadin-text-field',										
											name: 'trailerVinNo',
											label: 'Vin',
											maxLength: 120											
										},	
										{
											tag: 'vaadin-combo-box',											
											label: 'Make',
											name: 'trailerMake',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TrailerMake').then(function (data) {
													combo.items = data;
												});
											},
											listeners: {
												change: function(e) {
													var combo = e.target;			
													if (combo.invalid) {
														combo.invalid = false;
													}
												}
											}
										},										
										{
											tag: 'vaadin-combo-box',											
											label: 'Type',
											name: 'trailerType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: 'OTH',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TrailerType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'comment',
											label: 'Comment',
											maxLength: 255
										},										
										{
											//wrap to make sure the layout works
											tag: 'div',											
											children: [
												{
													tag: 'dl-tagfield',
													name: 'tags',
													label: 'Tags',
													maxLength: 80
												}
											]
										},
										{
											tag: 'dl-section-title',
											title: 'Tanks',
											colspan: 2,
											style: 'margin-top: 20px;'											
										},
										{
											tag: 'div',
											style: 'height: 300px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [	
														{
															tag: 'dl-fueltank-grid',
															itemid: 'tanksgrid',
															slot: 'primary'
														}
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																		
																													
															formPanel.submitForm({
																preSubmit: function(data) {			
																	data.tanks = ElementUtil.query(formPanel, 'tanksgrid').getTanks();	
																	
																	if (data.trailerMake === '') {
																		delete data.trailerMake;
																	}
																	
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.trailerId = record.trailerId;
																	}
																	return UnitService.getTrailerService().saveTrailer(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Trailer', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);
							
							ElementUtil.query(formPanel, 'tanksgrid').updateTanks(record.tanks);
						
						}
					}
				}
			});			
		};
		
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'TRAILER,UNITS',
				visibleOptions: [
					'datafilterId',
					'dataTransformRuleSetId',
					'autoGroupId'
				],
				uploadUrl: '/api/resource/trailers/import'
			});
		};
	
		var actionDetails = function(record) {
			UnitTools.displayDetails({
				record: record,
				grid: grid,	
				allData: grid.items.slice(0),
				selectField: 'trailerId',
				getDetails: function(data){
					var detail = [
						{
							key: 'Trailer Id',
							value: data.trailerId
						},
						{
							key: 'Trailer Ref No',
							value: data.trailerRefNo
						},
						{
							key: 'Vin',
							value: data.trailerVinNo
						},
						{
							key: 'Make',
							value: data.trailerMakeDesc ? data.trailerMakeDesc : ''
						},
						{
							key: 'Trailer Type',
							value: data.trailerTypeDesc ? data.trailerTypeDesc : ''
						},											
						{
							key: 'Deactivate Date',
							value: data.deactivateDts ? TimeUtil.formatDateStandard(data.deactivateDts) : "N/A"  
						},						
						{
							key: 'Comment',
							value: data.comment ? data.comment : ''
						},
						{	
							key: 'Update Date',
							value: TimeUtil.formatDateStandard(data.updateDts)
						},
						{	
							key: 'Update User',
							value: data.updateUser
						}						
					];
					UnitTools.insertV6EntityIdDetail(detail, data);
					
					if (data.tags) {
						detail.push({
							key: 'Tags',
							section: true,
							value: ''
						});
						data.tags.forEach(function(tag){
							detail.push({
								key: '',							
								value: tag
							});
						});
					}
					
					if (data.tankViews) {
						detail.push({
							key: 'Tank(s)',
							section: true,
							value: ''
						});
						data.tankViews.forEach(function(tank){
							detail.push({
								key: 'Tank Id',							
								value: tank.tankId
							});
							detail.push({
								key: 'Fuel Type',							
								value: tank.fuelTypDescription
							});
							detail.push({
								key: 'Tank Capacity',							
								value: tank.tankCapacity
							});
							detail.push({
								key: 'Quantity UOM',							
								value: tank.quantityUOM
							});
							detail.push({
								key: 'Actual',							
								value: tank.actual
							});
							detail.push({
								key: 'Average Tank Levels Ratio',							
								value: tank.aveTankLevelRatio ? tank.aveTankLevelRatio : ''
							});
						});
					}
					
					return detail;	
				}		
				
			});
		};
		
		var actionUpdateStatus = function(record) {
			
			if (record.activeStatus === 'A') {
				UnitService.getTrailerService().inactivateTrailer(record.trailerId).then(function(){
					window.DL.MessageUtil.showToast('Success', 'Inactivated - ' + record.trailerRefNo);
					actionRefresh();
				});
			} else {
				UnitService.getTrailerService().activateTrailer(record.trailerId).then(function(){
					window.DL.MessageUtil.showToast('Success', 'Activated - ' + record.trailerRefNo);
					actionRefresh();
				});				
			}
			
		};
		
		var actionMultiRefs = function(record) {
			UnitTools.multipleReferences({
				loadRefs: function(grid) {
					UnitService.getTrailerService().getTrailerMultiRefs(record.trailerId).then(function(data){
						grid.items = data;
					});
				},
				saveReference: function(data, edit) {
					data.trailerId = record.trailerId;
					return UnitService.getTrailerService().saveTrailerMultiRef(data, edit);
				},
				handleDelete: function(referenceId, successCallback) {
					UnitService.getTrailerService().deleteTrailerMultiRef(record.trailerId, referenceId).then(function(){
						successCallback();
					});
				}
			});
		};
		
	}
	
}
customElements.define('dl-trailer-grid', TrailerGrid);